export { default } from '../en/faq-coloring-options';



// WEBPACK FOOTER //
// ./src/components/async/enfaq-coloring-options.js